import { render, staticRenderFns } from "./MarketAreaTab.vue?vue&type=template&id=cb6da954"
import script from "./MarketAreaTab.vue?vue&type=script&lang=js"
export * from "./MarketAreaTab.vue?vue&type=script&lang=js"
import style0 from "./MarketAreaTab.vue?vue&type=style&index=0&id=cb6da954&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports